/**
 * WorkspaceSwitcher — centralized copy strings (AOF 25, i18n posture).
 */

export const workspaceSwitcherCopy = {
  prefix: "workspace",
  toggleLabel: "switch workspace",
  empty: "no workspace",
  chevron: "▾",
} as const;
